import React, { FunctionComponent, useEffect, useState } from 'react';
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';
import { useNavigate } from "react-router-dom";
import { statusView } from './CommonControls';
import { ICompany, IPomReportDataInfo, IUserCompanies, REPORTSTATUS } from '../util/DataModelInterface';
import * as reportApi from '../api/PomReport';
import useToastHandler from '../hooks/useToastHandler';
import { getCurrentPeriodString, getDeadline } from '../util/FormatDateUtil';
import { getCompany } from '../api/Company';

interface IReportStatusProps {
  selectedCompany?: IUserCompanies;
}

export const ReportStatus: FunctionComponent<IReportStatusProps> = (props) => {
  const navigate = useNavigate();
  const { addToast } = useToastHandler();

  const [report, setReport] = useState({} as IPomReportDataInfo);
  const [companyName, setCompanyName] = useState("");
  const [company, setCompany] = useState({} as ICompany);
  const [fetchState, setFetchState] = useState(false);

  useEffect(() => {
    if (props.selectedCompany?.id) {
      // console.log("reportStatus selectedCompany", props.selectedCompany?.name);
      setCompanyName(props.selectedCompany.name as string);
      let id = parseInt(props.selectedCompany.id);
      let period = getCurrentPeriodString();
      reportApi.getReportStatus([id], period).then((data: any) => {
        if (data?.error) {
          addToast(data.error, 'reports', 'fetch');
        } else if (data && data[0]) {
          setReport(data[0]);
        }
        setFetchState(true);
      }).then(() => {
        if (props.selectedCompany?.id) {
          return getCompany(props.selectedCompany.id);
        }
      }).then((data: any) => {
        if (data?.error) {
          addToast(data.error, 'reports', 'fetch');
        } else if (data) {
          setCompany(data);
        }
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedCompany]);

  return (
    <>
      <div className="highlight_bg mb-4">
        <div className="d-flex flex-row align-items-center ">
          <h3><FormattedMessage id="reports.currentperiod"/><FormattedDate value={getCurrentPeriodString()} month="long" year="numeric"/> </h3>
        </div>
        <div className="d-flex flex-row align-items-start">
          {!props.selectedCompany?.id &&
            <div className="alert alert-warning w-50">
                <div className="d-flex flex-row">
                    <i className="fa fa-warning me-2"></i>
                    <div>
                      <p><FormattedMessage id="user.status.noreport"/></p>
                    </div>
                </div>
            </div>
          }
          {props.selectedCompany?.id &&
          <>
            <p className="details-info me-4">
              <span className="key"><FormattedMessage id="reports.state"/></span>
              <span className="value reportperiod">
                { fetchState &&
                  statusView(report?.status ? report.status : "MISSING", getDeadline(new Date(getCurrentPeriodString())) )
                }
                {
                  !report?.status && company.reporting_interval > "1" &&
                  <small className="text-muted">
                    <i className="mx-2 fa fa-calendar"></i>
                    <FormattedMessage id="companies.reportingperiod"/>: {company.reporting_interval} <FormattedMessage id="reports.interval"/>
                  </small>
                }
                { report.modified &&
                  <small className="text-muted">
                    <i className="mx-2 fa fa-calendar"></i>
                    <FormattedDate value={report.modified}/> <FormattedTime value={report.modified}/>
                  </small>
                }
              </span>
            </p>
            { fetchState && report?.status &&
              <button className= {report?.status === REPORTSTATUS.NEW ? "btn btn-primary ms-5" : "poc btn btn-secondary"}
                disabled={!report || !report.report_id}
                      onClick={ () => { navigate("/reports/report", { replace: false, state: { companyId: report.company, companyName: companyName, period: getCurrentPeriodString(), status: report.status, confirm: false }});}}>
                {report?.status === REPORTSTATUS.NEW && <i className="fa fa-plus-circle me-2"></i>}
                <FormattedMessage id={report?.status === REPORTSTATUS.NEW ? "reports.addreport" : "reports.openreport"}/>
              </button>
            }
          </>
          }
        </div>
      </div>
    </>
  );
};